<template>
  <form @submit.prevent="search()">
    <div class="row">
      <div class="col-8 px-0">
        <form-group :validations="$v.words" class="w-100">
          <div slot-scope="{ errors, invalid }">
            <input class="form-control search-input-4-input" v-model="words" type="text"
                   :placeholder="placeHolder" autocomplete="off">
            <form-errors-manager class="search-input-4-error-message" :errors="errors"/>
          </div>
        </form-group>
      </div>
      <div class="col-2 px-0">
        <m-bt301 type="submit" class="mr-1 search-input-4-button text-white">
          جستجو
        </m-bt301>
      </div>
    </div>
  </form>
</template>

<script>
import router from "@/router";
import FormGroup from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormGroup.vue";
import FormErrorsManager
  from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormErrorsManager.vue";
import {required} from "vuelidate/lib/validators";

export default {
  name: "SearchInput4",
  components: {FormGroup, FormErrorsManager,},
  props: {
    placeHolder: {
      default: 'جست و جو'
    }

  },
  data() {
    return {
      words: '',
      type: 'product',
    }
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    search() {
      if (this.invalid()) {
        router.push({name: 'Search', params: {words: this.words, type: this.type}})
      }
    }
  },
  validations: {
    words: {required},
  },
}
</script>

<style scoped>
.search-input-4-button {
  background: var(--primary);
}
</style>